enum EnumHardwareType {
	Cpu = 0,
	HardDriveFreeSize = 1
}
export default EnumHardwareType
